import React from "react";
import { connect } from "react-redux";
import CuentaCorriente from "../../components/CuentaCorriente";
import { instalacionSelector } from "../../selectors/sessionSelector";

const CuentaCorrienteContainer = ({ instalacion }) => {
  return (
    <div style={{ minHeight: "100vh" }}>
      <CuentaCorriente instalacion={instalacion} />
    </div>
  );
};

const mapStateToProps = (state) => ({
  instalacion: instalacionSelector(state),
});

export default connect(mapStateToProps)(CuentaCorrienteContainer);
